import { Form, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import './secciones.scss';
import { ACTA_HALLAZGO } from 'constants/tipoMonitoreos';

const SeccionDatosGenerales = ({ form, tipoMon, tipoActa }) => {
  return (
    <div>
      <Form form={form} layout="horizontal">
        <div className="container-datos">
          {(() => {
            switch (tipoMon) {
              case 1:
                if (tipoActa !== ACTA_HALLAZGO) {
                  return (
                    <div className="container-datos">
                      <Form.Item name="proceso">
                        <Checkbox
                          className="check-campos"
                          onChange={({ target }) => {
                            form.setFieldsValue({ proceso: target.checked });
                          }}>
                          Proceso
                        </Checkbox>
                      </Form.Item>
                      <Form.Item name="horaApertura">
                        <Checkbox
                          className="check-campos"
                          onChange={({ target }) => {
                            form.setFieldsValue({ horaApertura: target.checked });
                          }}>
                          Hora de apertura
                        </Checkbox>
                      </Form.Item>
                      <Form.Item name="horaCierre">
                        <Checkbox
                          className="check-campos"
                          onChange={({ target }) => {
                            form.setFieldsValue({ horaCierre: target.checked });
                          }}>
                          Hora de cierre
                        </Checkbox>
                      </Form.Item>
                    </div>
                  );
                }
                return (
                  <div className="container-datos">
                    <Form.Item name="tipoEleccion">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ tipoEleccion: target.checked });
                        }}>
                        Tipo Elección
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="proceso">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ proceso: target.checked });
                        }}>
                        Proceso
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="ambito">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ ambito: target.checked });
                        }}>
                        Ámbito
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="distritoFederal">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ distritoFederal: target.checked });
                        }}>
                        Distrito Federal
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="distritoLocal">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ distritoLocal: target.checked });
                        }}>
                        Distrito Local
                      </Checkbox>
                    </Form.Item>
                  </div>
                );
              case 2:
                return (
                  <div className="container-datos">
                    <Form.Item name="entidad">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ entidad: target.checked });
                        }}>
                        Entidad
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="proceso">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ proceso: target.checked });
                        }}>
                        Proceso
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="descripcionPeriodo">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ descripcionPeriodo: target.checked });
                        }}>
                        Descripción del periodo
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="ambito">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ ambito: target.checked });
                        }}>
                        Ámbito
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="distritoFederal">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ distritoFederal: target.checked });
                        }}>
                        Distrito Federal
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="distritoLocal">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ distritoLocal: target.checked });
                        }}>
                        Distrito Local
                      </Checkbox>
                    </Form.Item>
                  </div>
                );
              case 3:
                return (
                  <div className="container-datos">
                    <Form.Item name="entidad">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ entidad: target.checked });
                        }}>
                        Entidad
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="proceso">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ proceso: target.checked });
                        }}>
                        Proceso
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="municipio">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ municipio: target.checked });
                        }}>
                        Municipio o Alcaldía
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="ambito">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ ambito: target.checked });
                        }}>
                        Ámbito
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="distritoFederal">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ distritoFederal: target.checked });
                        }}>
                        Distrito Federal
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="distritoLocal">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ distritoLocal: target.checked });
                        }}>
                        Distrito Local
                      </Checkbox>
                    </Form.Item>
                  </div>
                );
              case 4:
                return (
                  <div className="container-datos">
                    <Form.Item name="entidad">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ entidad: target.checked });
                        }}>
                        Entidad
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="proceso">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ proceso: target.checked });
                        }}>
                        Proceso
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="ambito">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ ambito: target.checked });
                        }}>
                        Ámbito
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="distritoFederal">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ distritoFederal: target.checked });
                        }}>
                        Distrito Federal
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="distritoLocal">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ distritoLocal: target.checked });
                        }}>
                        Distrito Local
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="acuerdoCOF">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ acuerdoCOF: target.checked });
                        }}>
                        Acuerdo COF
                      </Checkbox>
                    </Form.Item>
                    <Form.Item name="fechaAcuerdoCOF">
                      <Checkbox
                        className="check-campos"
                        onChange={({ target }) => {
                          form.setFieldsValue({ fechaAcuerdoCOF: target.checked });
                        }}>
                        Fecha de Acuerdo de la COF
                      </Checkbox>
                    </Form.Item>
                  </div>
                );
              default:
                return null;
            }
          })()}
        </div>
      </Form>
    </div>
  );
};

export default SeccionDatosGenerales;

SeccionDatosGenerales.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired,
  tipoMon: PropTypes.number.isRequired,
  tipoActa: PropTypes.number.isRequired
};
